<template>
  <el-row style="height: 100%">
    <el-col
      v-for="(mould, index) in moulds"
      :key="index"
      :md="6"
      :sm="12"
      :xs="12"
      :class="loose ? 'mould-detail-loose' : 'mould-detail'"
    >
      <div class="detail-wrapper" @click="goToDetails(mould)">
        <div class="mould-image-wrapper">
          <img
            v-lazy="mould.attachList[0].fileUrl"
            class="mould-image"
            :alt="mould.name"
          />
        </div>
        <div class="mould-name">{{ mould.name }}</div>
        <el-tooltip
          popper-class="mould-tooltip"
          :content="mould.introduce"
          placement="top"
        >
          <div class="mould-introduce">{{ mould.introduce }}</div>
        </el-tooltip>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import "./_FullCategory.scss";
export default {
  name: "MouldExhibition",
  props: {
    moulds: Array,
    type: Number,
    disable: {
      type: Boolean,
      default: false,
    },
    loose: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    showCustomerService() {
      this.$store.commit("showCustomerService");
    },
    goToDetails(mold) {
      if (!this.disable) {
        this.$router.push({
          path: `/product-detail/${mold.name
            .split(" ")
            .map((it) => it.toLowerCase())
            .join("-")}/${mold.id}`,
        });
      }
    },
  },
};
</script>
